<template>
  <p>Not found</p>
</template>

<script>
export default {}
</script>
